import styled from "styled-components"
import { MdWarning } from "react-icons/md"

export const Row = styled.div`
  display: grid;
  grid-gap: 10px;
  grid-template-columns: repeat(${(props) => props.span || 1}, 1fr);
  width: 100%;
`

export const Container = styled.div`
  height: 100%;
  max-height: ${(props) => props.maxHeight};
  width: 100%;
  display: flex;
  flex-direction: row;
  padding: 10px;

  @media (max-width: 425px) {
    max-height: 100%;
  }
`

export const FilterContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 10px;
`

export const RoleContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  gap: 10px;
  align-items: center;

  & span {
    min-width: 280px;
    max-width: 280px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`

export const EventInclude = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

export const Warning = styled(MdWarning).attrs({
  color: "red"
})`
  margin: 3px;
`
